<template>
  <div class="app-page">
    <PageHeader />
    <div class="application-page-container">
      <a-tabs
        v-model:activeKey="activeKey"
        @change="handleTabChange"
        type="card"
      >
        <a-tab-pane key="career-guide" :tab="$t('admin.Career Guide')">
          <section>
            <div class="btn-action-group">
              <a-button
                class="btn-item btn-upload"
                @click="uploadGuideVisible = true"
                :disabled="!canUpLoad"
              >
                <template #icon>
                  <upload-outlined />
                </template>
                {{ $t('admin.Upload Career Guide') }}
              </a-button>
              <a-button
                @click="
                  downLoadFileFromUrl('/template/guide.xlsx', 'guide.xlsx')
                "
                class="btn-item btn-download"
              >
                {{ $t('admin.Download EN Template') }}
              </a-button>
              <a-button
                @click="
                  downLoadFileFromUrl(
                    '/template/guide_cn.xlsx',
                    'guide_cn.xlsx'
                  )
                "
                class="btn-item btn-download"
              >
                下载中文模版
              </a-button>
              <a-modal
                v-model:visible="uploadGuideVisible"
                centered
                width="663px"
                :title="$t('admin.Upload Career Guide')"
                class="Career Guid-uploade-dialog"
                :loading="loading"
              >
                <template #footer>
                  <a-button
                    key="submit"
                    type="primary"
                    :loading="loading"
                    :disabled="
                      this.fileCareerGuideEN == null ||
                      this.fileCareerGuideCN == null
                    "
                    @click="uploadExcel('career-guide')"
                  >
                    {{ $t('admin.Upload') }}
                  </a-button>
                </template>
                <div class="uploade-dialog">
                  <div class="step-tip-text">
                    1.
                    {{ $t('admin.Please download the template for uploading') }}
                  </div>

                  <a-button
                    class="btn-item btn-export"
                    @click="
                      downLoadFileFromUrl('/template/guide.xlsx', 'guide.xlsx')
                    "
                  >
                    <template #icon>
                      <DownloadOutlined />
                    </template>
                    {{ $t('admin.Download EN Template') }}
                  </a-button>

                  <a-button
                    class="btn-item btn-export-cn"
                    @click="
                      downLoadFileFromUrl(
                        '/template/guide_cn.xlsx',
                        'guide_cn.xlsx'
                      )
                    "
                  >
                    <template #icon>
                      <DownloadOutlined />
                    </template>
                    下载中文模版
                  </a-button>

                  <div class="step-tip-text">
                    2.
                    {{
                      $t(
                        'admin.Select the file (System will renew the items in the list from the uploaded document)'
                      )
                    }}
                  </div>
                  <div class="upload-wrapper upload-en-wrapper">
                    <a-upload
                      class="btn-upload"
                      :action="uploadDataUrl"
                      :headers="{ Authorization }"
                      :beforeUpload="beforeUploadEN"
                      :showUploadList="false"
                      :disabled="!canUpLoad"
                    >
                      <a-button :disabled="!canUpLoad">
                        <upload-outlined></upload-outlined>
                        {{ $t('admin.Upload EN File') }}
                      </a-button>
                      <span class="file-name">
                        {{ fileCareerGuideEN ? fileCareerGuideEN.name : '' }}
                      </span>
                    </a-upload>
                    <CheckOutlined
                      v-if="fileCareerGuideEN"
                      style="color: #ac7f40; font-size: 18px"
                    />
                    <CloseOutlined
                      v-else
                      style="color: #f44336; font-size: 18px"
                    />
                  </div>
                  <div class="upload-wrapper">
                    <a-upload
                      class="btn-upload"
                      :action="uploadDataUrl"
                      :headers="{ Authorization }"
                      :beforeUpload="beforeUploadCN"
                      :showUploadList="false"
                      :disabled="!canUpLoad"
                    >
                      <a-button :disabled="!canUpLoad">
                        <upload-outlined></upload-outlined>
                        上传中文版文件
                      </a-button>
                      <span class="file-name">
                        {{ fileCareerGuideCN ? fileCareerGuideCN.name : '' }}
                      </span>
                    </a-upload>
                    <CheckOutlined
                      v-if="fileCareerGuideCN"
                      style="color: #ac7f40; font-size: 18px"
                    />
                    <CloseOutlined
                      v-else
                      style="color: #f44336; font-size: 18px"
                    />
                  </div>
                </div>
              </a-modal>
            </div>
            <a-input-search
              clss="input-search-panel"
              v-model:value="keyword"
              allow-clear
              :placeholder="$t('admin.File Name / Creator')"
              :loading="loading"
              @search="onSearch"
            />
          </section>
          <section class="application-counter">
            <div class="counter-text">
              <span>
                {{ $t('admin.Total') }}: {{ pagination.total }}
                {{
                  pagination.total > 1 ? $t('admin.Files') : $t('admin.File')
                }}
              </span>
            </div>
          </section>
          <a-table
            class="job-table"
            :rowKey="(record) => record.id"
            :columns="columns"
            :data-source="guideHistories"
            @change="onChange"
            :pagination="false"
          >
            <template v-slot:emptyText>
              <Empty />
            </template>
            <template v-slot:headerCell="{ title }">
              <template v-if="title === 'EN/中文'">
                {{ title }}
              </template>
              <template v-else>
                {{ $t('admin.' + title) }}
              </template>
            </template>
            <template v-slot:bodyCell="{ record, column }">
              <template v-if="column.key === 'show_name'">
                <div
                  :class="`guide_filename ${
                    record.is_active ? 'current' : null
                  }`"
                >
                  <div class="status-indicator" />
                  <div>{{ record.show_name }}</div>
                </div>
              </template>
              <template v-if="column.key === 'action'">
                <a-button type="link" @click="downloadCareerGuide(record)">
                  {{ $t('admin.Download') }}
                </a-button>
                <a-button type="link" @click="renameCareerGuide(record)">
                  {{ $t('admin.Rename') }}
                </a-button>
                <a-button
                  type="link"
                  @click="delCareerGuide(record)"
                  :disabled="record.is_active"
                >
                  {{ $t('admin.Delete') }}
                </a-button>
              </template>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="learning-link" :tab="$t('admin.Learning Link')">
          <section>
            <div class="btn-action-group">
              <a-button
                class="btn-item btn-upload"
                @click="uploadLearningLinkVisible = true"
              >
                <template #icon>
                  <upload-outlined />
                </template>
                {{ $t('admin.Upload Learning Link') }}
              </a-button>
              <a-button
                @click="
                  downLoadFileFromUrl(
                    '/template/learning-link.xlsx',
                    'learning-link.xlsx'
                  )
                "
                class="btn-item btn-download"
              >
                {{ $t('admin.Download EN Template') }}
              </a-button>
              <a-button
                @click="
                  downLoadFileFromUrl(
                    '/template/learning-link_cn.xlsx',
                    'learning-link_cn.xlsx'
                  )
                "
                class="btn-item btn-download"
              >
                下载中文模版
              </a-button>
              <a-modal
                v-model:visible="uploadLearningLinkVisible"
                centered
                width="663px"
                :title="$t('admin.Upload Learning Link')"
                class="Learning Link-uploade-dialog"
                :loading="loading"
              >
                <template #footer>
                  <a-button
                    key="submit"
                    type="primary"
                    :loading="loading"
                    @click="uploadExcel('learning-link')"
                    :disabled="
                      this.fileLearningLinkEN == null ||
                      this.fileLearningLinkCN == null
                    "
                  >
                    {{ $t('admin.Upload') }}
                  </a-button>
                </template>
                <div class="uploade-dialog">
                  <div class="step-tip-text">
                    1.
                    {{ $t('admin.Please download the template for uploading') }}
                  </div>

                  <a-button
                    class="btn-item btn-export"
                    @click="
                      downLoadFileFromUrl(
                        '/template/learning-link.xlsx',
                        'learning-link.xlsx'
                      )
                    "
                  >
                    <template #icon>
                      <DownloadOutlined />
                    </template>
                    {{ $t('admin.Download EN Template') }}
                  </a-button>
                  <a-button
                    class="btn-item btn-export-cn"
                    @click="
                      downLoadFileFromUrl(
                        '/template/learning-link_cn.xlsx',
                        'learning-link_cn.xlsx'
                      )
                    "
                  >
                    <template #icon>
                      <DownloadOutlined />
                    </template>
                    下载中文模版
                  </a-button>

                  <div class="step-tip-text">
                    2.
                    {{
                      $t(
                        'admin.Select the file (System will renew the items in the list from the uploaded document)'
                      )
                    }}
                  </div>

                  <div class="upload-wrapper upload-en-wrapper">
                    <a-upload
                      class="btn-upload"
                      :action="uploadLearningResourceDataUrl"
                      :headers="{ Authorization }"
                      :beforeUpload="beforeUploadEN"
                      :showUploadList="false"
                    >
                      <a-button>
                        <upload-outlined></upload-outlined>
                        {{ $t('admin.Upload EN File') }}
                      </a-button>
                      <span class="file-name">
                        {{ fileLearningLinkEN ? fileLearningLinkEN.name : '' }}
                      </span>
                    </a-upload>
                    <CheckOutlined
                      v-if="fileLearningLinkEN"
                      style="color: #ac7f40; font-size: 18px"
                    />
                    <CloseOutlined
                      v-else
                      style="color: #f44336; font-size: 18px"
                    />
                  </div>
                  <div class="upload-wrapper">
                    <a-upload
                      class="btn-upload"
                      :action="uploadLearningResourceDataUrl"
                      :headers="{ Authorization }"
                      :beforeUpload="beforeUploadCN"
                      :showUploadList="false"
                    >
                      <a-button>
                        <upload-outlined></upload-outlined>
                        上传中文版文件
                      </a-button>
                      <span class="file-name">
                        {{ fileLearningLinkCN ? fileLearningLinkCN.name : '' }}
                      </span>
                    </a-upload>
                    <CheckOutlined
                      v-if="fileLearningLinkCN"
                      style="color: #ac7f40; font-size: 18px"
                    />
                    <CloseOutlined
                      v-else
                      style="color: #f44336; font-size: 18px"
                    />
                  </div>
                </div>
              </a-modal>
            </div>
            <a-input-search
              clss="input-search-panel"
              v-model:value="keyword_learning_resource"
              allow-clear
              :placeholder="$t('admin.File Name / Creator')"
              :loading="loading"
              @search="onSearch"
            />
          </section>
          <section class="application-counter">
            <div class="counter-text">
              <span>
                {{ $t('admin.Total') }}: {{ pagination.total }}
                {{
                  pagination.total > 1 ? $t('admin.Files') : $t('admin.File')
                }}
              </span>
            </div>
          </section>
          <a-table
            class="job-table"
            :rowKey="(record) => record.id"
            :columns="columns"
            :data-source="learningResourceHistories"
            @change="onChange"
            :pagination="false"
          >
            <template v-slot:emptyText>
              <Empty />
            </template>
            <template v-slot:headerCell="{ title }">
              <template v-if="title === 'EN/中文'">
                {{ title }}
              </template>
              <template v-else>
                {{ $t('admin.' + title) }}
              </template>
            </template>
            <template v-slot:bodyCell="{ record, column }">
              <template v-if="column.key === 'show_name'">
                <div
                  :class="`guide_filename ${
                    record.is_active ? 'current' : null
                  }`"
                >
                  <div class="status-indicator" />
                  <div>{{ record.show_name }}</div>
                </div>
              </template>
              <template v-if="column.key === 'action'">
                <a-button type="link" @click="downloadCareerGuide(record)">
                  {{ $t('admin.Download') }}
                </a-button>
                <a-button type="link" @click="renameCareerGuide(record)">
                  {{ $t('admin.Rename') }}
                </a-button>
                <a-button
                  type="link"
                  @click="delCareerGuide(record)"
                  :disabled="record.is_active"
                >
                  {{ $t('admin.Delete') }}
                </a-button>
              </template>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="learning-record" :tab="$t('admin.Learning Record')">
          <section>
            <div class="btn-action-group">
              <div class="btn-action-group">
                <a-button
                  class="btn-item btn-upload"
                  @click="uploadLearningRecordVisible = true"
                >
                  <template #icon>
                    <upload-outlined />
                  </template>
                  {{ $t('admin.Upload Learning Record') }}
                </a-button>
                <a-button
                  @click="
                    downLoadFileFromUrl(
                      '/template/learning-record.xlsx',
                      'learning-record.xlsx'
                    )
                  "
                  class="btn-item btn-download"
                >
                  {{ $t('admin.Download EN Template') }}
                </a-button>
                <a-button
                  @click="
                    downLoadFileFromUrl(
                      '/template/learning-record_cn.xlsx',
                      'learning-record_cn.xlsx'
                    )
                  "
                  class="btn-item btn-download"
                >
                  下载中文模版
                </a-button>
                <a-modal
                  v-model:visible="uploadLearningRecordVisible"
                  centered
                  width="663px"
                  :title="$t('admin.Upload Learning Record')"
                  class="Learning Link-uploade-dialog"
                  :loading="loading"
                >
                  <template #footer>
                    <a-button
                      key="submit"
                      type="primary"
                      :loading="loading"
                      @click="uploadExcel('learning-record')"
                      :disabled="
                        fileLearningRecordEN == null ||
                        fileLearningRecordCN == null
                      "
                    >
                      {{ $t('admin.Upload') }}
                    </a-button>
                  </template>
                  <div class="uploade-dialog">
                    <div class="step-tip-text">
                      1.
                      {{
                        $t('admin.Please download the template for uploading')
                      }}
                    </div>

                    <a-button
                      class="btn-item btn-export"
                      @click="
                        downLoadFileFromUrl(
                          '/template/learning-record.xlsx',
                          'learning-record.xlsx'
                        )
                      "
                    >
                      <template #icon>
                        <DownloadOutlined />
                      </template>
                      {{ $t('admin.Download EN Template') }}
                    </a-button>
                    <a-button
                      class="btn-item btn-export-cn"
                      @click="
                        downLoadFileFromUrl(
                          '/template/learning-record_cn.xlsx',
                          'learning-record_cn.xlsx'
                        )
                      "
                    >
                      <template #icon>
                        <DownloadOutlined />
                      </template>
                      下载中文模版
                    </a-button>

                    <div class="step-tip-text">
                      2.
                      {{
                        $t(
                          'admin.Select the file (System will renew the items in the list from the uploaded document)'
                        )
                      }}
                    </div>

                    <div class="upload-wrapper upload-en-wrapper">
                      <a-upload
                        class="btn-upload"
                        :action="uploadLearningRecordDataUrl"
                        :headers="{ Authorization }"
                        :beforeUpload="beforeUploadEN"
                        :showUploadList="false"
                      >
                        <a-button>
                          <upload-outlined></upload-outlined>
                          {{ $t('admin.Upload EN File') }}
                        </a-button>
                        <span class="file-name">
                          {{
                            fileLearningRecordEN
                              ? fileLearningRecordEN.name
                              : ''
                          }}
                        </span>
                      </a-upload>
                      <CheckOutlined
                        v-if="fileLearningRecordEN"
                        style="color: #ac7f40; font-size: 18px"
                      />
                      <CloseOutlined
                        v-else
                        style="color: #f44336; font-size: 18px"
                      />
                    </div>
                    <div class="upload-wrapper">
                      <a-upload
                        class="btn-upload"
                        :action="uploadLearningRecordDataUrl"
                        :headers="{ Authorization }"
                        :beforeUpload="beforeUploadCN"
                        :showUploadList="false"
                      >
                        <a-button>
                          <upload-outlined></upload-outlined>
                          上传中文版文件
                        </a-button>
                        <span class="file-name">
                          {{
                            fileLearningRecordCN
                              ? fileLearningRecordCN.name
                              : ''
                          }}
                        </span>
                      </a-upload>
                      <CheckOutlined
                        v-if="fileLearningRecordCN"
                        style="color: #ac7f40; font-size: 18px"
                      />
                      <CloseOutlined
                        v-else
                        style="color: #f44336; font-size: 18px"
                      />
                    </div>
                  </div>
                </a-modal>
              </div>
            </div>
            <a-input-search
              clss="input-search-panel"
              v-model:value="keyword_learning_record"
              allow-clear
              :placeholder="$t('admin.File Name / Creator')"
              :loading="loading"
              @search="onSearch"
            />
          </section>
          <section class="application-counter">
            <div class="counter-text">
              <span>
                {{ $t('admin.Total') }}: {{ pagination.total }}
                {{
                  pagination.total > 1 ? $t('admin.Files') : $t('admin.File')
                }}
              </span>
            </div>
          </section>
          <a-table
            class="job-table"
            :rowKey="(record) => record.id"
            :columns="columns"
            :data-source="learningRecordHistories"
            @change="onChange"
            :pagination="false"
          >
            <template v-slot:emptyText>
              <Empty />
            </template>
            <template v-slot:headerCell="{ title }">
              <template v-if="title === 'EN/中文'">
                {{ title }}
              </template>
              <template v-else>
                {{ $t('admin.' + title) }}
              </template>
            </template>
            <template v-slot:bodyCell="{ record, column }">
              <template v-if="column.key === 'show_name'">
                <div
                  :class="`guide_filename ${
                    record.is_active ? 'current' : null
                  }`"
                >
                  <div class="status-indicator" />
                  <div>{{ record.show_name }}</div>
                </div>
              </template>
              <template v-if="column.key === 'action'">
                <a-button type="link" @click="downloadCareerGuide(record)">
                  {{ $t('admin.Download') }}
                </a-button>
                <a-button type="link" @click="renameCareerGuide(record)">
                  {{ $t('admin.Rename') }}
                </a-button>
                <a-button
                  type="link"
                  @click="delCareerGuide(record)"
                  :disabled="record.is_active"
                >
                  {{ $t('admin.Delete') }}
                </a-button>
              </template>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <a-modal
      v-model:visible="renameVisible"
      :title="$t('admin.Rename File')"
      centered
      @ok="renameFileHandleOk"
      :ok-text="$t('admin.Save')"
      :cancel-text="$t('admin.Cancel')"
    >
      <div class="form-field-title">{{ $t('admin.File Name') }}</div>
      <a-input
        v-model:value="fileTemplate.show_name"
        placeholder="File New Name"
      />
    </a-modal>
    <a-modal
      v-model:visible="historyVisible"
      centered
      width="674px"
      title="View History"
      class="history-uploade-dialog"
    >
      <template #footer>
        <a-button key="submit" type="primary" @click="historyVisible = false">
          Close
        </a-button>
      </template>
      <a-table
        class="history-table"
        :rowKey="(record) => record.id"
        :columns="[
          { title: 'User', key: 'user', dataIndex: 'user' },
          { title: 'Action', key: 'action', dataIndex: 'action' },
          { title: 'File Name', key: 'filename', dataIndex: 'filename' },
          {
            title: 'Time of Action',
            key: 'time',
            dataIndex: 'time',
          },
        ]"
        :data-source="historyList"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { Modal, message } from 'ant-design-vue'
  import PageHeader from '../components/PageHeader.vue'
  import {
    getGuideHistory,
    confirmGuideUpload,
    getEmployeeHistoy,
    renameGuide,
    deleteGuide,
    exportGuideData,
    uploadFile,
    uploadTwoLanguageFiles,
  } from '@/api/admin'
  import {
    UploadOutlined,
    DownloadOutlined,
    CheckOutlined,
    CloseOutlined,
  } from '@ant-design/icons-vue'
  import { downLoadFileFromRequest, downLoadFileFromUrl } from '@/utils/index'
  import {
    getLearningResourceHistory,
    getLearningRecordHistory,
  } from '../../../api/admin'
  import Empty from '@/components/Empty'

  export default {
    name: 'Index',
    components: {
      PageHeader,
      UploadOutlined,
      DownloadOutlined,
      CheckOutlined,
      CloseOutlined,
      Empty,
    },
    data() {
      return {
        loading: false,
        uploadGuideVisible: false,
        uploadLearningLinkVisible: false,
        uploadLearningRecordVisible: false,
        uploadDataUrl: '/import/Guide',
        uploadLearningResourceDataUrl: '/import/LearningResource',
        uploadLearningRecordDataUrl: '/import/LearningRecord',
        keyword: '',
        keyword_learning_resource: '',
        keyword_learning_record: '',
        filteredInfo: {},
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
        },
        fileCareerGuideEN: null,
        fileCareerGuideCN: null,
        fileLearningLinkEN: null,
        fileLearningLinkCN: null,
        fileLearningRecordEN: null,
        fileLearningRecordCN: null,
        guideHistories: [],
        learningResourceHistories: [],
        learningRecordHistories: [],
        activeKey: 'career-guide',
        renameVisible: false,
        fileTemplate: {},
        historyVisible: false,
        historyList: [],
        //
        tmpFile: null,
      }
    },
    computed: {
      columns() {
        return [
          {
            title: 'File Name',
            key: 'show_name',
            dataIndex: 'show_name',
          },
          {
            title: 'Creator',
            key: 'user',
            dataIndex: 'user',
          },
          {
            title: 'Upload Time',
            key: 'time',
            dataIndex: 'time',
          },
          {
            title: 'EN/中文',
            key: 'language',
            dataIndex: 'language',
          },
          {
            title: 'Action',
            key: 'action',
            width: 300,
          },
        ]
      },
      ...mapGetters({
        Authorization: 'user/accessToken',
        ability: 'acl/ability',
      }),
      canUpLoad() {
        const ability = this.ability.find(
          (item) => item.key === 'can_upload_guide'
        )
        return ability.value || true
      },
      canUpLoadLearningResource() {
        const ability = this.ability.find(
          (item) => item.key === 'can_upload_learning_link'
        )
        return ability.value
      },
      canUpLoadLearningRecord() {
        const ability = this.ability.find(
          (item) => item.key === 'can_upload_learning_record'
        )
        return ability.value
      },
    },
    created() {
      this.fetchData()
    },
    watch: {
      uploadVisible: {
        handler(newVal) {
          if (!newVal) {
            this.tmpFile = null
          }
        },
      },
    },
    methods: {
      handleTabChange(curr) {
        this.fetchData()
      },
      downLoadFileFromUrl,

      async fetchData() {
        await this.$store.dispatch('user/getUserInfo')
        if (this.activeKey == 'career-guide') {
          getGuideHistory({
            keywords: this.keyword,
          }).then((res) => {
            if (res.code === 200) {
              this.guideHistories = res.data
              this.pagination.total = res.data.length
            }
          })
        }
        if (this.activeKey == 'learning-link') {
          getLearningResourceHistory({
            keywords: this.keyword_learning_resource,
          }).then((res) => {
            if (res.code === 200) {
              this.learningResourceHistories = res.data
              this.pagination.total = res.data.length
            }
          })
        }
        if (this.activeKey == 'learning-record') {
          getLearningRecordHistory({
            keywords: this.keyword_learning_record,
          }).then((res) => {
            if (res.code === 200) {
              this.learningRecordHistories = res.data
              this.pagination.total = res.data.length
            }
          })
        }
      },
      onSearch() {
        this.fetchData()
      },
      onChange() {},
      downloadCareerGuide(record) {
        exportGuideData(this.Authorization, record.id).then(
          downLoadFileFromRequest
        )
      },
      renameCareerGuide(rowData) {
        this.fileTemplate = JSON.parse(JSON.stringify(rowData))
        this.renameVisible = true
      },
      renameFileHandleOk() {
        const fid = this.fileTemplate.id
        const filename = this.fileTemplate.show_name
        renameGuide(fid, filename).then((res) => {
          if (res.code === 200) {
            this.renameVisible = false
            message.success(this.$t('admin.Renamed successfully.'))
            let source = this.guideHistories
            if (this.activeKey == 'learning-link') {
              source = this.learningResourceHistories
            }
            if (this.activeKey == 'learning-record') {
              source = this.learningRecordHistories
            }
            const record = source.find((item) => item.id === fid)
            if (record != null) {
              record.show_name = filename
            }
          }
        })
      },
      delCareerGuide(rowData) {
        const fid = rowData.id
        const vm = this
        Modal.confirm({
          title: this.$t('admin.Delete File'),
          okText: this.$t('admin.Yes'),
          cancelText: this.$t('admin.No'),
          closable: true,
          content: this.$t('admin.Are you sure you want to delete the file?'),
          onOk() {
            deleteGuide(fid).then((res) => {
              if (res.code === 200) {
                message.success('Record deleted successfully.')

                if (vm.activeKey == 'career-guide') {
                  const recordIndex = vm.guideHistories.findIndex(
                    (item) => item.id === fid
                  )
                  vm.guideHistories.splice(recordIndex, 1)
                }
                if (vm.activeKey == 'learning-link') {
                  const recordIndex = vm.learningResourceHistories.findIndex(
                    (item) => item.id === fid
                  )
                  vm.learningResourceHistories.splice(recordIndex, 1)
                }
                if (vm.activeKey == 'learning-record') {
                  const recordIndex = vm.learningRecordHistories.findIndex(
                    (item) => item.id === fid
                  )
                  vm.learningRecordHistories.splice(recordIndex, 1)
                }
              }
            })
          },
        })
      },
      uploadExcel(type) {
        function checkBrackets(file) {
          if (file.name.match(/\(|\)/g)) {
            return true
          } else {
            return false
          }
        }
        const vm = this
        let url
        let files
        if (type == 'career-guide') {
          url = this.uploadDataUrl
          files = [vm.fileCareerGuideEN, vm.fileCareerGuideCN]
          files.map((file) => {
            if (checkBrackets(file)) {
              message.error('文件名不能包含括号')
              return false
            }
          })
        }
        if (type == 'learning-link') {
          url = this.uploadLearningResourceDataUrl
          files = [vm.fileLearningLinkEN, vm.fileLearningLinkCN]
          files.map((file) => {
            if (checkBrackets(file)) {
              message.error('文件名不能包含括号')
              return false
            }
          })
        }
        if (type == 'learning-record') {
          url = this.uploadLearningRecordDataUrl
          files = [vm.fileLearningRecordEN, vm.fileLearningRecordCN]
          files.map((file) => {
            if (checkBrackets(file)) {
              message.error('文件名不能包含括号')
              return false
            }
          })
        }
        if (files && files.length == 2) {
          uploadTwoLanguageFiles(url, files[0], files[1])
            .then((res) => {
              if (res.code == 200) {
                message.success(`Files uploaded successfully`)
                this.fetchData()
                this.uploadGuideVisible = false
                this.uploadLearningLinkVisible = false
                this.uploadLearningRecordVisible = false
              } else if (res.code == 301) {
                const fid = res.fId
                if (type == 'career-guide') {
                  Modal.confirm({
                    title: this.$t('admin.Upload Guide'),
                    okText: this.$t('admin.Yes'),
                    cancelText: this.$t('admin.No'),
                    closable: true,
                    content: this.$t(
                      'admin.Found the duplicated data. Do you want to replace?'
                    ),
                    onOk() {
                      confirmGuideUpload(fid).then((res) => {
                        if (res.code == 200) {
                          message.success('Uploaded successfully.')
                          vm.fetchData()
                          vm.uploadGuideVisible = false
                          vm.uploadLearningLinkVisible = false
                          vm.uploadLearningRecordVisible = false
                        }
                      })
                    },
                  })
                }
              } else {
                message.error(res.msg)
              }
            })
            .catch((err) => {
              console.log(err)
              message.error(err.msg || 'upload failed.')
            })
            .finally(() => {
              this.file = null
            })
        }
      },
      beforeUploadEN(file) {
        return this.beforeUpload(file, 'en')
      },
      beforeUploadCN(file) {
        return this.beforeUpload(file, 'cn')
      },
      beforeUpload(file, lang) {
        const isExcel =
          file.type === 'application/vnd.ms-excel' ||
          file.type ===
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        if (!isExcel) {
          message.error(this.$t('admin.Incorrect Excel template type.'))
        }
        switch (this.activeKey) {
          case 'career-guide':
            if (lang == 'en') {
              this.fileCareerGuideEN = file
            } else {
              this.fileCareerGuideCN = file
            }
            break
          case 'learning-link':
            if (lang == 'en') {
              this.fileLearningLinkEN = file
            } else {
              this.fileLearningLinkCN = file
            }
            break
          case 'learning-record':
            if (lang == 'en') {
              this.fileLearningRecordEN = file
            } else {
              this.fileLearningRecordCN = file
            }
            break
        }
        return false
      },
      handleUploadDataChange({ file }) {
        const vm = this
        if (file && file.status === 'done') {
          if (file.response.code == 200) {
            message.success(`${file.name} file uploaded successfully`)
            this.fetchData()
          } else if (file.response.code == 301) {
            const fid = file.response.fId
            Modal.confirm({
              title: this.$t('admin.Upload Guide'),
              okText: this.$t('admin.Yes'),
              cancelText: this.$t('admin.No'),
              closable: true,
              content: this.$t(
                'admin.Found the duplicated data. Do you want to replace?'
              ),
              onOk() {
                confirmGuideUpload(fid).then((res) => {
                  if (res.code == 200) {
                    message.success('Uploaded successfully.')
                    vm.fetchData()
                  }
                })
              },
            })
          } else {
            message.error(file.response.msg)
          }
        } else if (file && file.status === 'error') {
          message.error(`${file.name} file upload failed.`)
        }
      },
      showHistory() {
        getEmployeeHistoy().then((res) => {
          if (res.code === 200) {
            this.historyList = res.data
            this.historyVisible = true
          }
        })
      },
      handleModalCancel() {},
      handleManualUpload() {
        if (!this.tmpFile) return
        const that = this
        if (this.tmpFile.response.code == 200) {
          message.success(`${this.tmpFile.name} file uploaded successfully`)
          this.fetchData()
        } else if (this.tmpFile.response.code == 301) {
          const fid = this.tmpFile.response.fId
          Modal.confirm({
            title: this.$t('admin.Upload Guide'),
            okText: this.$t('admin.Yes'),
            cancelText: this.$t('admin.No'),
            closable: true,
            content: this.$t(
              'admin.Found the duplicated data. Do you want to replace?'
            ),
            onOk() {
              confirmGuideUpload(fid).then((res) => {
                if (res.code == 200) {
                  message.success('Uploaded successfully.')
                  that.fetchData()
                }
              })
            },
          })
        } else {
          message.error(this.tmpFile.response.msg)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');

  .application-page-container {
    margin: @app-conetent-margin;
    background-color: white;
    padding: 24px;
    section {
      display: flex;
      justify-content: space-between;
    }
    .btn-action-group {
      .btn-upload {
        margin-right: 12px;
      }

      .btn-download:nth-child(2) {
        margin-right: 12px;
      }
    }
    .input-search-panel {
      width: 285px;
    }

    .application-counter {
      padding: 24px 0;
      align-items: center;
      .counter-text {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        span {
          margin-right: 12px;
        }
      }
    }
  }

  .table-pagination {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .form-field-title {
    font-size: 14px;
    font-family: Helvetica;
    color: #333333;
    line-height: 22px;
    margin: 8px 0;
  }
  :deep {
    .table-pagination,
    .page-pagination {
      .ant-pagination-item-active {
        a {
          color: white;
        }
        background-color: @primary-color;
      }
    }
  }
  .guide_filename {
    display: flex;
    // justify-content: center;
    align-items: center;
    .status-indicator {
      width: 8px;
      height: 8px;
      min-width: 8px;
      border-radius: 100%;
      margin-right: 8px;
      background-color: #999;
    }
    &.current {
      .status-indicator {
        background-color: #43a047;
      }
    }
  }
  .uploade-dialog {
    .step-tip-text {
      font-size: 14px;
      font-family: Helvetica;
      color: #333333;
      line-height: 17px;
      margin: 20px 0;
    }

    .btn-export {
      margin-right: 12px;
    }

    .radio-group {
      display: flex;
      flex-direction: column;

      .radio {
        margin-bottom: 8px;
      }
    }

    .upload-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .upload-en-wrapper {
      margin-bottom: 20px;
    }
  }
  .file-name {
    margin-left: 10px;
  }
</style>
